module.exports = __webpack_public_path__ + "img/bg.e40f0a76.png";